module.exports = __webpack_public_path__ + "static/img/mp1.ebbedf99.png";